import {
  ContainerCardRule,
  Title,
  ImageTrophy,
  Button,
  ImageSupporter,
} from "./CardStatistik.styled";
import { func } from "../../../utils";
import useWindowSize from "../../../hooks/useWindowSize";
import { usePageContextFunction } from "../../../context/PageContext";
import moment from "moment";

const PointSupporterStateCard = ({
  text,
  category,
  badgeCity,
  onClick,
  data,
}) => {
  const { setOpenPopUp: toglePopUp } = usePageContextFunction();
  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 768;

  return (
    <div
      onClick={() => {
        toglePopUp({
          state: true,
          data: "",
          currentCity: "supporter",
        });
      }}
    >
      <ContainerCardRule
        className="bg-[#0397C9]"
        img={func.getStaticImg("/illustration/brush-4.png")}
        width={"100%"}
        height={"132px"}
        padding={isMobileView ? "30px 16px" : "30px 56px"}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            columnGap: isMobileView ? 16 : 56,
            alignItems: "center",
          }}
        >
          <ImageSupporter
            src={func.getStaticImg("/illustration/supporter.svg")}
          />
          <div
            style={{
              color: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              //gap: isMobileView ? "4px" : "24px",
            }}
          >
            {/* <Title
              fontSize={isMobileView ? "14px" : "28px"}
              lineHeight={"24px"}
              color={"#1F2D3D"}
            >
              {`Apa itu Poin Supporter (PS*)?`}
            </Title> */}
            <span className="text-[16px] lg:text-[20px]">Apa itu</span>
            <span className="text-[18px] lg:text-[28px] font-semibold">
              {"Poin Supporter (PS*)?"}
            </span>
            {isMobileView ? (
              <Button
                className="border-white mt-2"
                fontSize={isMobileView ? "14px" : "16px"}
                height={isMobileView ? "24px" : "44px"}
                width={isMobileView ? "fit-content" : "217px"}
                style={{ borderRadius: isMobileView ? "16px" : "40px" }}
              >
                <span
                  className="text-white font-semibold items-center"
                  style={{
                    margin: isMobileView ? "0px" : "12px",
                    display: "inline-flex",
                  }}
                >
                  Lihat info detail
                  <img
                    src={func.getStaticImg("/icon/right-arrow-white.svg")}
                    style={{ marginLeft: 8 }}
                  ></img>
                </span>
              </Button>
            ) : null}
          </div>
          {!isMobileView ? (
            <Button
              className="border-white"
              fontSize={isMobileView ? "14px" : "16px"}
              height={isMobileView ? "24px" : "44px"}
              width={isMobileView ? "fit-content" : "217px"}
              style={{ borderRadius: isMobileView ? "16px" : "40px" }}
            >
              <span
                className="text-white font-semibold items-center"
                style={{
                  margin: isMobileView ? "0px" : "12px",
                  display: "inline-flex",
                }}
              >
                Lihat info detail
                <img
                  src={func.getStaticImg("/icon/right-arrow-white.svg")}
                  style={{ marginLeft: 8 }}
                ></img>
              </span>
            </Button>
          ) : null}
        </div>
      </ContainerCardRule>
    </div>
  );
};

export default PointSupporterStateCard;
